import { css } from '@linaria/atomic'
import { getThemeSpacing } from '../../styles/appTheme'
import APP_BREAKPOINTS, { minWindowWidth } from '../../styles/breakpoints'
import { palette } from '../../styles/colors'
import { APP_FONT } from '../../theme'

export const rootStyles = css`
    padding-top: ${getThemeSpacing(1)};
    padding-bottom: ${getThemeSpacing(1)};
    padding-left: ${getThemeSpacing(3)};
    padding-right: ${getThemeSpacing(3)};
    max-width: 500px;
    ${minWindowWidth(APP_BREAKPOINTS.sm)} {
        padding-top: ${getThemeSpacing(2)};
        padding-bottom: ${getThemeSpacing(2)};
        padding-left: ${getThemeSpacing(2)};
        padding-right: ${getThemeSpacing(2)};
    }
`
export const junkStyles = css`
    margin: 0;
    font-size: 0.75rem;
    line-height: 1.66;
    margin-bottom: ${getThemeSpacing(3)};
    font-weight: 600;
    color: ${palette.mfcWarning};
`
export const verificationStyles = css`
    margin: ${getThemeSpacing()} 0;
    color: ${palette.greenMFC};
    line-height: 1.66;
    letter-spacing: 0.0333em;
    font-size: 0.75rem;
    font-weight: 400;
`
export const refreshStyles = css`
    display: block;
    margin: auto;
`

export const reload = () => {
    location.reload()
}

export const eyeIconStyle = css`
    position: absolute;
    top: 16px;
    right: 16px;
    color: #777;
    cursor: pointer;
`

export const smallEyeIconStyle = css`
    position: absolute;
    top: 7px;
    right: 12px;
    color: #777;
    cursor: pointer;
`

export const validationWarningStyles = css`
    font-family: ${APP_FONT};
    font-weight: 500;
`
